/** Normalize an optional timestamp input to an ISO string (defaults to now). */
export function toIso(now?: Date | string): string {
  if (now == null) return new Date().toISOString();
  return typeof now === 'string' ? now : now.toISOString();
}
